import React from "react";
import { Button, Grid, Typography } from "@mui/material";
import { Autorenew as ResendIcon } from "@mui/icons-material";

const ResendOTPButton = ({ onClick, disabled }) => {
  return (
    <Grid container alignItems="center" justifyContent="flex-end">
      <Typography variant="body2" sx={{ paddingRight: "6px" }}>
        Didn't get OTP?
      </Typography>
      <Button
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
        onClick={onClick}
        startIcon={<ResendIcon />}
        disabled={disabled}
      >
        Resend OTP
      </Button>
    </Grid>
  );
};

export default ResendOTPButton;
